
import { useLanguage } from '@/lib/i18n';
import { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Globe, Users, MapPin, Zap } from 'lucide-react';

const WestbalkanSection = () => {
  const { tr } = useLanguage();
  const [open, setOpen] = useState(false);

  // Öffne Popup, wenn CustomEvent von Navbar kommt
  useState(() => {
    const handler = () => setOpen(true);
    window.addEventListener('openWestbalkanProcessPopup', handler);
    return () => window.removeEventListener('openWestbalkanProcessPopup', handler);
  });

  const cards = [
    { icon: Zap, titleKey: 'westbalkan.card1.title', descKey: 'westbalkan.card1.desc' },
    { icon: Users, titleKey: 'westbalkan.card2.title', descKey: 'westbalkan.card2.desc' },
    { icon: MapPin, titleKey: 'westbalkan.card3.title', descKey: 'westbalkan.card3.desc' },
    { icon: Globe, titleKey: 'westbalkan.card4.title', descKey: 'westbalkan.card4.desc' },
  ];

  return (
    <section className="py-8 md:py-12 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-xl mx-auto mb-6">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-2">
            {tr('westbalkan.title')}
          </h2>
          <p className="text-muted-foreground text-base mb-4">
            {tr('pathway.westbalkan.info')}
          </p>
          <Button onClick={() => setOpen(true)} className="mt-2">
            {tr('westbalkan.cta')}
          </Button>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogContent>
            <h3 className="font-heading text-xl font-bold mb-4">{tr('westbalkan.title')}</h3>
            <p className="text-muted-foreground text-base mb-6">{tr('westbalkan.subtitle')}</p>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
              {cards.map((card, i) => (
                <div key={card.titleKey} className="bg-white rounded-lg p-6 card-shadow">
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                    <card.icon className="w-6 h-6 text-primary" />
                  </div>
                  <h4 className="font-heading text-lg font-semibold text-foreground mb-2">
                    {tr(card.titleKey)}
                  </h4>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {tr(card.descKey)}
                  </p>
                </div>
              ))}
            </div>
            {/* Vermittlungsprozess als Info im Modal */}
            <div className="mt-8">
              <h4 className="font-heading text-lg font-bold mb-3">{tr('process.title')}</h4>
              <div className="grid md:grid-cols-4 gap-4">
                <div className="bg-card rounded-lg p-4 text-center">
                  <div className="font-heading text-primary text-2xl mb-2">1</div>
                  <div className="font-semibold mb-1">{tr('process.step1.title')}</div>
                  <div className="text-sm text-muted-foreground">{tr('process.step1.desc')}</div>
                </div>
                <div className="bg-card rounded-lg p-4 text-center">
                  <div className="font-heading text-primary text-2xl mb-2">2</div>
                  <div className="font-semibold mb-1">{tr('process.step2.title')}</div>
                  <div className="text-sm text-muted-foreground">{tr('process.step2.desc')}</div>
                </div>
                <div className="bg-card rounded-lg p-4 text-center">
                  <div className="font-heading text-primary text-2xl mb-2">3</div>
                  <div className="font-semibold mb-1">{tr('process.step3.title')}</div>
                  <div className="text-sm text-muted-foreground">{tr('process.step3.desc')}</div>
                </div>
                <div className="bg-card rounded-lg p-4 text-center">
                  <div className="font-heading text-primary text-2xl mb-2">4</div>
                  <div className="font-semibold mb-1">{tr('process.step4.title')}</div>
                  <div className="text-sm text-muted-foreground">{tr('process.step4.desc')}</div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

export default WestbalkanSection;
